
import React from 'react';
import { DesignSuggestion } from '../types.ts';

interface DesignSuggestionPDFProps {
    suggestion: DesignSuggestion;
}

const DesignSuggestionPDF: React.FC<DesignSuggestionPDFProps> = ({ suggestion }) => {
  return (
    <div id="pdf-render-content" style={{ width: '210mm', height: '297mm', padding: '20mm', fontFamily: 'Helvetica, Arial, sans-serif', backgroundColor: '#ffffff', color: 'black', boxSizing: 'border-box' }}>
      {/* Title */}
      <h1 style={{ fontSize: '24pt', borderBottom: '2px solid #333', paddingBottom: '10px', margin: 0, color: '#b45309' }}>
        {suggestion.designName}
      </h1>
      
      {/* Image and Overview */}
      <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
        <div style={{ flex: 1.2, display: 'flex', flexDirection: 'column' }}>
          <h2 style={{ fontSize: '16pt', margin: '0 0 10px 0', color: '#333' }}>Concept Overview</h2>
          <p style={{ fontSize: '11pt', lineHeight: 1.5, margin: 0, color: '#555' }}>
            {suggestion.conceptOverview}
          </p>
          <h2 style={{ fontSize: '16pt', margin: '20px 0 10px 0', color: '#333' }}>Material</h2>
          <p style={{ fontSize: '11pt', margin: 0, color: '#555' }}>
            {suggestion.material}
          </p>
        </div>
        {suggestion.imageUrl && (
          <div style={{ flex: 1 }}>
            <img src={suggestion.imageUrl} style={{ width: '100%', borderRadius: '8px', border: '1px solid #eee' }} alt={suggestion.designName} />
          </div>
        )}
      </div>
      
      {/* Piece List Table */}
      <h2 style={{ fontSize: '16pt', marginTop: '25px', borderTop: '2px solid #333', paddingTop: '15px', color: '#333' }}>
        Piece List & Dimensions
      </h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f4' }}>
            <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left', fontSize: '10pt', fontWeight: 'bold' }}>Piece Name</th>
            <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left', fontSize: '10pt', fontWeight: 'bold' }}>Dimensions</th>
            <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left', fontSize: '10pt', fontWeight: 'bold' }}>Notes</th>
          </tr>
        </thead>
        <tbody>
          {suggestion.pieceList.map((piece, index) => (
            <tr key={index} style={{ pageBreakInside: 'avoid' }}>
              <td style={{ border: '1px solid #ddd', padding: '10px', fontSize: '10pt' }}>{piece.pieceName}</td>
              <td style={{ border: '1px solid #ddd', padding: '10px', fontSize: '10pt' }}>{piece.dimensions}</td>
              <td style={{ border: '1px solid #ddd', padding: '10px', fontSize: '10pt' }}>{piece.notes || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DesignSuggestionPDF;
